import { createSwupInstance } from '../core/swup/create-instance'

export const initSwup = (ctx) => {
	const swup = createSwupInstance(ctx)

	ctx.swup = swup
	// window.swup = swup

	return swup
}
